/* src/components/Chart.svelte generated by Svelte v3.57.0 */
import {
	SvelteComponent,
	check_outros,
	component_subscribe,
	create_component,
	destroy_component,
	detach,
	empty,
	group_outros,
	init,
	insert,
	mount_component,
	safe_not_equal,
	transition_in,
	transition_out
} from "../../_snowpack/pkg/svelte/internal.js";

import { Bar } from "../../_snowpack/pkg/svelte-chartjs.js";
import { expressionStore } from "./stores.js";

import {
	Chart,
	Title,
	Tooltip,
	Legend,
	BarElement,
	CategoryScale,
	LinearScale
} from "../../_snowpack/pkg/chartjs.js";

function create_if_block(ctx) {
	let bar;
	let current;

	bar = new Bar({
			props: {
				data: /*data*/ ctx[0],
				options: /*options*/ ctx[1]
			}
		});

	return {
		c() {
			create_component(bar.$$.fragment);
		},
		m(target, anchor) {
			mount_component(bar, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const bar_changes = {};
			if (dirty & /*data*/ 1) bar_changes.data = /*data*/ ctx[0];
			bar.$set(bar_changes);
		},
		i(local) {
			if (current) return;
			transition_in(bar.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(bar.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(bar, detaching);
		}
	};
}

function create_fragment(ctx) {
	let if_block_anchor;
	let current;
	let if_block = /*data*/ ctx[0] && create_if_block(ctx);

	return {
		c() {
			if (if_block) if_block.c();
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if (if_block) if_block.m(target, anchor);
			insert(target, if_block_anchor, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			if (/*data*/ ctx[0]) {
				if (if_block) {
					if_block.p(ctx, dirty);

					if (dirty & /*data*/ 1) {
						transition_in(if_block, 1);
					}
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					transition_in(if_block, 1);
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				group_outros();

				transition_out(if_block, 1, 1, () => {
					if_block = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if (if_block) if_block.d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let $expressionStore;
	component_subscribe($$self, expressionStore, $$value => $$invalidate(3, $expressionStore = $$value));
	let data;
	let expressions;
	Chart.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale);

	const options = {
		responsive: true,
		plugins: { legend: { display: false } }
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*$expressionStore, expressions*/ 12) {
			$: {
				$$invalidate(2, expressions = [...$expressionStore.entries()].filter(([,value]) => value.evaluation !== undefined).map(([key, value]) => ({ label: key, data: value.evaluation })));

				$$invalidate(0, data = {
					labels: expressions.map(a => a.label),
					datasets: [
						{
							label: "Símbolos",
							data: expressions.map(a => a.data),
							backgroundColor: "rgba(209, 135, 209, 0.5)",
							borderColor: "purple",
							borderWidth: 1,
							borderRadius: 4
						}
					]
				});
			}
		}
	};

	return [data, options, expressions, $expressionStore];
}

class Chart_1 extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default Chart_1;